import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class StockService {
  static stockCreate = async (product_id, color_id, size_id, quantity, price) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/stock/create",
        data: {
          product_id,
          color_id,
          size_id,
          quantity,
          price
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static stockDetails = async (rowsPerPage, page, searchTerm, productId) => {
    try {
          let filter = [];

          if (searchTerm) {
            filter.push({'invoice_number': searchTerm})
          }
          if(productId){
            filter.push({'productId': productId})
          }
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/stock/admin/search",
        data: {
          filter: filter,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let productDetail = response.data.data;
      return productDetail;
    } catch (err) {
      throw err;
    }
  };

  static stockDetailsSearch = async (rowsPerPage, page, productName) => {

    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/stock/search",
        data: {
          filter: [{"name": productName }],
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
   let stockDetail = response.data.data;
  return stockDetail;
    } catch (err) {
      throw err;
    }
  };


  static stockDetailsID = async (stockID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/stock/admin/" + stockID,
        data: {
          filter: [],
          limit: 10,
          skip: 0,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let stockDetailsID = response.data.data;

      return stockDetailsID;
    } catch (err) {
      throw err;
    }
  };

  static stockDelete = async (productID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/stock/" + productID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static stockUpdate = async (stockID, quantity, price) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/stock/update/" + stockID,
        data: {
          quantity: quantity,
          price: price
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };
}